import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface ToastState {
  visible: boolean;
  message: string | string[];
  options?: ToastOptions;
}

interface ToastOptions {
  timeout?: number;
  hideCloseButton?: boolean;
}

const initialState: ToastState = {
  visible: false,
  message: '',
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<Omit<ToastState, 'visible'>>) => {
      state.visible = true;
      state.message = action.payload.message;
      state.options = {
        timeout: action.payload.options?.timeout ?? 3000,
        hideCloseButton: action.payload.options?.hideCloseButton ?? false,
      };
    },
    hideToast: (state) => {
      state.visible = false;
      state.options = initialState.options;
    },
  },
});

export const toastActions = toastSlice.actions;
export default toastSlice;
